import Symbols from './mappings/symbols/Symbols';

export const SYMBOL_DRAWER_BASE_WIDTH = 320;
export const SYMBOL_DRAWER_MIN_WIDTH = 180;
export const SYMBOL_DRAWER_MIN_SCALE = 0.55;
export const SYMBOL_DRAWER_MAX_SCALE = 3;

const EXCLUDED_SYMBOL_LABELS = new Set([
  'Box',
  'TextBox',
  'StraightLine',
  'SymbolDrawer',
]);

export const getSymbolDrawerScale = (width) => {
  const normalizedWidth = Math.max(SYMBOL_DRAWER_MIN_WIDTH, Number(width) || SYMBOL_DRAWER_BASE_WIDTH);
  return Math.min(
    SYMBOL_DRAWER_MAX_SCALE,
    Math.max(SYMBOL_DRAWER_MIN_SCALE, normalizedWidth / SYMBOL_DRAWER_BASE_WIDTH),
  );
};

export const getSymbolDrawerContentHeight = (itemCount, width) => {
  const scale = getSymbolDrawerScale(width);
  const rows = Math.max(1, Number(itemCount) || 0);
  const paddingY = 24;
  const titleHeight = 16;
  const titleGap = 10;
  const rowHeight = 54;
  const tableBorderAllowance = 2;
  const outerBorderAllowance = 4;

  return Math.ceil(
    ((paddingY + titleHeight + titleGap + rows * rowHeight + tableBorderAllowance) * scale)
      + outerBorderAllowance
  );
};

const getSymbolCatalogItems = () => (
  Object.values(Symbols)
    .flatMap((group) => (Array.isArray(group) ? group : []))
    .filter(Boolean)
);

export const findCatalogSymbol = (nodeData = {}) => {
  const symbolLabel = nodeData.symbolLabel;
  const aliases = [
    nodeData.alias,
    nodeData.baseAlias,
    nodeData.variantAlias,
  ].filter(Boolean).map((value) => String(value).toLowerCase());
  const catalog = getSymbolCatalogItems();

  return catalog.find((item) => {
    if (!item) return false;
    const typeMatch = item.type === symbolLabel;
    const itemAliases = [
      item.alias,
      item.baseAlias,
      item.variantAlias,
    ].filter(Boolean).map((value) => String(value).toLowerCase());
    return typeMatch && (aliases.length === 0 || itemAliases.some((alias) => aliases.includes(alias)));
  }) || catalog.find((item) => item?.type === symbolLabel) || null;
};

export const getNodeInspectorSymbolName = (node) => {
  const data = node?.data || {};
  const catalogSymbol = findCatalogSymbol(data);
  const catalogLabel = typeof catalogSymbol?.label === 'string' && catalogSymbol.label.trim()
    ? catalogSymbol.label.trim()
    : null;
  return catalogLabel || data.label || data.symbolLabel || 'Símbolo';
};

export const getNodeSymbolImage = (node) => {
  const data = node?.data || {};
  const catalogSymbol = findCatalogSymbol(data);
  return data.diagramSvgSrc || data.svgSrc || catalogSymbol?.diagramSvgSrc || catalogSymbol?.svgSrc || null;
};

export const getUsedSymbolDrawerItems = (nodes) => {
  const source = Array.isArray(nodes) ? nodes : [];
  const byName = new Map();
  source.forEach((node) => {
    const symbolLabel = node?.data?.symbolLabel;
    if (!symbolLabel || EXCLUDED_SYMBOL_LABELS.has(symbolLabel)) {
      return;
    }
    const name = getNodeInspectorSymbolName(node);
    const key = name.toLocaleLowerCase();
    if (!byName.has(key)) {
      byName.set(key, {
        key,
        name,
        symbolLabel,
        image: getNodeSymbolImage(node),
      });
    }
  });
  return Array.from(byName.values()).sort((a, b) => a.name.localeCompare(b.name));
};
